/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Error_TypeInputs */

const en_story_error_type = /** @type {(inputs: Story_Error_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsupported file type. Use JPEG, PNG, WebP, MP4, or WebM.`)
};

const es_story_error_type = /** @type {(inputs: Story_Error_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de archivo no admitido. Usa JPEG, PNG, WebP, MP4 o WebM.`)
};

const fr_story_error_type = /** @type {(inputs: Story_Error_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de fichier non pris en charge. Utilisez JPEG, PNG, WebP, MP4 ou WebM.`)
};

const de_story_error_type = /** @type {(inputs: Story_Error_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht unterstützter Dateityp. Verwende JPEG, PNG, WebP, MP4 oder WebM.`)
};

const id_story_error_type = /** @type {(inputs: Story_Error_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis file tidak didukung. Gunakan JPEG, PNG, WebP, MP4, atau WebM.`)
};

/** @type {(inputs: Story_Error_TypeInputs) => LocalizedString} */
const ja_story_error_type = en_story_error_type;

/** @type {(inputs: Story_Error_TypeInputs) => LocalizedString} */
const zh_story_error_type = en_story_error_type;

/** @type {(inputs: Story_Error_TypeInputs) => LocalizedString} */
const ar_story_error_type = en_story_error_type;

/** @type {(inputs: Story_Error_TypeInputs) => LocalizedString} */
const it_story_error_type = en_story_error_type;

/** @type {(inputs: Story_Error_TypeInputs) => LocalizedString} */
const ru_story_error_type = en_story_error_type;

/** @type {(inputs: Story_Error_TypeInputs) => LocalizedString} */
const pt_story_error_type = en_story_error_type;

/** @type {(inputs: Story_Error_TypeInputs) => LocalizedString} */
const ko_story_error_type = en_story_error_type;

/**
* | output |
* | --- |
* | "Unsupported file type. Use JPEG, PNG, WebP, MP4, or WebM." |
*
* @param {Story_Error_TypeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_error_type = /** @type {((inputs?: Story_Error_TypeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Error_TypeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_error_type(inputs)
	if (locale === "es") return es_story_error_type(inputs)
	if (locale === "fr") return fr_story_error_type(inputs)
	if (locale === "de") return de_story_error_type(inputs)
	if (locale === "ja") return ja_story_error_type(inputs)
	if (locale === "zh") return zh_story_error_type(inputs)
	if (locale === "ar") return ar_story_error_type(inputs)
	if (locale === "id") return id_story_error_type(inputs)
	if (locale === "it") return it_story_error_type(inputs)
	if (locale === "ru") return ru_story_error_type(inputs)
	if (locale === "pt") return pt_story_error_type(inputs)
	return ko_story_error_type(inputs)
});